
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import {
  CourseType,
  GetCourseTypeResponse,
  UpsertCourseTypeRequest,
} from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "CourseType",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading, padZero } = usePlugin();

    const courseTypeTable = ref(null);
    const courseTypes = ref<CourseType[]>([]);
    const courseType = ref<CourseType>({} as CourseType);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existCourseTypeId = ref(false);
    const duplicateCourseTypeId = ref(false);

    const filteredCourseType = computed(() => {
      if (!searchString.value) return courseTypes.value;
      const fuse = new Fuse(courseTypes.value, {
        keys: ["courseTypeId", "description"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadCourseTypes = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetCourseTypeResponse>(
          "api/v1/services/courseType/get"
        );
        courseTypes.value = result.data.courseTypes ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewCourseType = () => {
      courseType.value = {} as CourseType;
      showDialog.value = true;
      submitted.value = false;
      existCourseTypeId.value = false;
    };

    const onSaveCourseType = async () => {
      submitted.value = true;
      if (courseType.value.id && courseType.value.id.length > 0) {
        if (
          !existCourseTypeId.value &&
          courseTypes.value.find(
            (comp) => comp.id === padZero(courseType.value.id, 3)
          )
        ) {
          //Create courseType ID
          duplicateCourseTypeId.value = true;
          return;
        }
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/courseType/upsert", {
            courseTypes: [
              {
                id: padZero(courseType.value.id, 3),
                description: courseType.value.description,
              },
            ],
          } as UpsertCourseTypeRequest);
          await loadCourseTypes();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateCourseTypeId.value = false;
    };

    const onEditCourseType = (source: CourseType) => {
      courseType.value = clone(source);
      showDialog.value = true;
      existCourseTypeId.value = true;
    };

    const onDeleteCourseType = (source: CourseType) => {
      courseType.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteCourseType = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/courseType/delete", {
          data: {
            courseTypes: [courseType.value],
          } as UpsertCourseTypeRequest,
        });
        await loadCourseTypes();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
        popupDeleteDialog.value = false;
      } finally {
        setLoading(false);
      }
      // }
    };

    onMounted(async () => {
      await loadCourseTypes();
    });
    return {
      courseTypeTable,
      courseType,
      courseTypes,
      filteredCourseType,
      showDialog,
      submitted,
      existCourseTypeId,
      duplicateCourseTypeId,
      popupDeleteDialog,
      searchString,
      onNewCourseType,
      onEditCourseType,
      onDeleteCourseType,
      onSaveCourseType,
      handleDeleteCourseType,
      onHideDialog,
    };
  },
};
